import 'swiper/css/bundle';
import Swiper, {Mousewheel} from 'swiper';

Swiper.use([Mousewheel]);

import './gallery-video.scss';

const galleryVideoCarousel = () => {
    let gallery = {
        slidesPerView: "auto",
        spaceBetween: 10,
        mousewheel: {
          forceToAxis: true,
        },
        breakpoints: {
            768: {
              spaceBetween: 40
            },
          }
    };

    let gallerySwiper = new Swiper(document.querySelector('.gallery-videoSwiper'), gallery);
}

export default galleryVideoCarousel;